import React, { memo } from 'react'
import classNames from 'classnames'
import { Box, makeStyles } from 'transfix-ui/core'
import { ReactComponent as LogoFMSSvg } from './LogoFMS.svg'
import { ReactComponent as LogoTMSSvg } from './LogoTMS.svg'

type logoSize = 'xsmall' | 'small' | 'large'
export interface ILogoProps {
  className?: string
  logoStyle?: 'white' | 'black'
  logoSize?: logoSize
  width?: string
  height?: string
}

export const HeaderLogo = memo<ILogoProps>(
  ({ className = '', logoSize = 'large', logoStyle = 'white' }) => {
    const fillStyle = logoStyle === 'white' ? '#FFFFFF' : '#000000'
    const defaultLogoSize = { width: '200px', height: '60px' }
    const smallLogoSize = { width: '101px', height: '12px' }
    const size = logoSize === 'small' ? smallLogoSize : defaultLogoSize

    return (
      <svg
        aria-hidden='true'
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 1612.4 196.7'
        width={size.width}
        height={size.height}
        className={className}>
        <g>
          <g>
            <polygon
              fill={fillStyle}
              points='1612.4,28.7 1564.6,28.7 1524.3,70.5 1484,28.7 1436.2,28.7 1501.7,96.2 1436.2,168.1 1481.1,168.1
            1524.3,121.1 1567.5,168.1 1612.4,168.1 1546.8,96.2'
            />
          </g>
          <polygon
            fill={fillStyle}
            points='262.1,58.2 320,58.2 320,168.1 359.6,168.1 359.6,58.2 417.6,58.2 417.6,28.7 262.1,28.7'
          />
          <path
            fill={fillStyle}
            d='M689.2,28.7l-69.5,139.4h42.8l13.3-29.3h76.4l13.3,29.3h42.8L738.9,28.7H689.2z M687.6,113.4l26.2-61.1h0.6l26.2,61.1
          H687.6z'
          />
          <polygon
            fill={fillStyle}
            points='954.9,123.5 870.7,28.7 828.3,28.7 828.3,168.1 864.2,168.1 864.2,72.3 951.4,168.1 990.9,168.1 990.9,28.7
          954.9,28.7'
          />
          <path
            fill={fillStyle}
            d='M1126.8,83.6l-38.3-3.9c-17.9-1.8-23.6-5.1-23.6-13.5c0-9.6,11.6-14.7,33.2-14.7c26.7,0,46.7,8.2,56.9,22.2l25.1-21
          c-17.5-19.6-45-28.9-80.1-28.9c-47.7,0-74.8,16.5-74.8,44.2c0,25.7,16.7,38.3,50.7,42l42.8,4.7c16.5,1.8,22.4,5.3,22.4,13.9
          c0,11-11.8,16.3-37.1,16.3c-28.5,0-49.9-11.2-61.5-27.5l-28.3,19.8c14.3,22,46.5,35.7,87.8,35.7c50.5,0,79.1-17.3,79.1-48.3
          C1181.2,99,1165.3,87.6,1126.8,83.6z'
          />
          <polygon
            fill={fillStyle}
            points='1205.7,168.1 1245.4,168.1 1245.4,113.3 1342.5,113.3 1342.5,84.3 1245.4,84.3 1245.4,58.2 1346.5,58.2
          1346.5,28.7 1205.7,28.7'
          />
          <rect fill={fillStyle} x='1371.8' y='28.7' width='39.7' height='139.4' />
          <path
            fill={fillStyle}
            d='M597.4,67.1c0-22.3-26.4-38.4-56.1-38.4h-97.6v139.4h40.7v-48.9h54c10.8,0,14.9,3.2,14.9,13.9v35H594v-46.4
          c0-13.3-6.4-20.5-22.7-20.5C586.1,97,597.4,84.4,597.4,67.1z M530.8,93.5h-46.4V55.2h46.4c15.5,0,24.7,5.7,24.7,17.6
          C555.5,84.2,546.4,93.5,530.8,93.5z'
          />
        </g>
        <g>
          <polygon
            fill='#00C28A'
            points='76.9,196.7 158.6,196.7 81.7,98.4 158.6,0 124.6,0 47.7,98.4 92,155.1 78.3,155.1 34,98.4 110.9,0
          76.9,0 0,98.4'
          />
          <polygon
            fill={fillStyle}
            points='158.6,0 76.9,0 153.8,98.4 76.9,196.7 110.9,196.7 187.8,98.4 143.5,41.7 157.2,41.7 201.5,98.4 124.6,196.7
          158.6,196.7 235.5,98.4'
          />
        </g>
      </svg>
    )
  }
)

export const FooterLogo = memo<ILogoProps>(({ className = '', logoSize, logoStyle = 'black' }) => {
  const fillStyle = logoStyle === 'white' ? '#FFFFFF' : '#000000'
  const defaultLogoSize = { width: '192px', height: '156px' }
  const smallLogoSize = { width: '40px', height: '40px' }
  const xsmallLogoSize = { width: '19.15px', height: '16px' }
  const size = (logo?: logoSize) => {
    switch (logo) {
      case 'xsmall':
        return xsmallLogoSize
      case 'small':
        return smallLogoSize
      default:
        return defaultLogoSize
    }
  }
  return (
    <svg
      aria-hidden='true'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 235.5 196.7'
      width={size(logoSize)?.width}
      height={size(logoSize)?.height}
      className={className}>
      <g>
        <polygon
          fill='#00C28A'
          points='76.9,196.7 158.6,196.7 81.7,98.4 158.6,0 124.6,0 47.7,98.4 92,155.1 78.3,155.1 34,98.4 110.9,0
          76.9,0 0,98.4'
        />
        <polygon
          fill={fillStyle}
          points='158.6,0 76.9,0 153.8,98.4 76.9,196.7 110.9,196.7 187.8,98.4 143.5,41.7 157.2,41.7 201.5,98.4 124.6,196.7
          158.6,196.7 235.5,98.4'
        />
      </g>
    </svg>
  )
})

interface IDatProps {
  className?: string
  width?: string
}

export const Dat = memo<IDatProps>(({ width = '192px' }) => (
  <svg version='1.1' id='Layer_1' width={width} aria-hidden='true' viewBox='0 0 1008 316.8'>
    <rect x='337' y='19.6' width='280' height='280' />
    <rect x='15' y='19.6' width='280' height='280' />
    <rect x='659' y='19.6' width='280' height='280' />
    <g>
      <path
        d='M990.2,24.5c-3.3-3.2-7.5-4.9-12.5-4.9c-5,0-9.3,1.7-12.6,5c-3.4,3.4-5.1,7.5-5.1,12.4c0,5,1.6,9.1,4.9,12.4
c3.3,3.2,7.5,4.9,12.6,4.9c5,0,9.2-1.7,12.6-5c3.4-3.3,5.1-7.5,5.1-12.4C995.2,31.9,993.5,27.8,990.2,24.5z M988.3,47.9
c-2.9,2.9-6.5,4.4-10.7,4.4c-4.3,0-7.9-1.5-10.8-4.4c-2.9-2.9-4.4-6.5-4.4-10.9c0-4.3,1.4-7.9,4.3-10.8c2.9-2.9,6.5-4.3,10.9-4.3
c4.3,0,7.9,1.5,10.8,4.3c2.9,2.9,4.4,6.5,4.4,10.8C992.7,41.3,991.2,45,988.3,47.9z'
      />
      <path
        d='M983.5,41.8c-1.1-2.4-2.3-3.7-3.5-3.9v-0.1c1.7-0.4,3-1.1,3.9-2.2c0.9-1,1.4-2.3,1.4-3.8c0-1.9-0.7-3.4-2.1-4.4
c-1.4-1.1-3.5-1.6-6.3-1.6h-6.6v22h4v-8.9h1.7c1.2,0,2.3,1.2,3.3,3.6l2.1,5.3h4.9L983.5,41.8z M977,35.6h-2.7v-6.4h2.2
c1.6,0,2.8,0.2,3.5,0.6c0.7,0.4,1.1,1.2,1.1,2.5c0,1-0.4,1.8-1.1,2.4C979.2,35.4,978.2,35.6,977,35.6z'
      />
    </g>
    <polygon
      style={{ fill: '#FFFFFF' }}
      points='715.5,110.9 774.2,110.9 774.2,248.8 824.1,248.8 824.1,110.9 882.7,110.9 882.7,69.6 715.5,69.6'
    />
    <g>
      <polygon
        style={{ fill: '#FFFFFF' }}
        points='579,248.8 503.6,69.6 503.5,69.6 450.3,69.6 450.2,69.6 374.8,248.8 423.7,248.8 435.9,219.8 517.9,219.8 530.1,248.8'
      />
      <polygon points='476.9,126.1 453.3,182.2 500.5,182.2' />
    </g>
    <g>
      <path
        style={{ fill: '#FFFFFF' }}
        d='M144.9,69.6H74.4v179.2h70.5c50,0,90.6-40.2,90.6-89.6C235.6,109.8,194.9,69.6,144.9,69.6z'
      />
      <path d='M136.5,112.4H124V206h12c30.1,0,48-17.5,48-46.8C184.1,130.3,165.9,112.4,136.5,112.4z' />
    </g>
  </svg>
))

const ASPECT_RATIO = 68 / 174

const useHeaderLogoStyles = makeStyles({
  root: {
    position: 'relative',
    display: 'inline-block',
  },
  svg: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
  },
})

export const FMSHeaderLogo = memo<Omit<ILogoProps, 'height'>>(
  ({ className: classNameProp = '', logoStyle = 'white', width = '174px' }) => {
    const fillStyle = logoStyle === 'white' ? '#FFFFFF' : '#000000'
    const heightPx = ASPECT_RATIO * Number(width.replace('px', ''))
    const classes = useHeaderLogoStyles()
    return (
      <Box color={fillStyle} width={width} height={heightPx} className={classes.root}>
        <LogoFMSSvg className={classNames(classes.svg, classNameProp)} />
      </Box>
    )
  }
)

/**
 * @deprecated in favor of shipper app re-branding.
 */
export const TMSHeaderLogo = memo<Omit<ILogoProps, 'height'>>(
  ({ className: classNameProp = '', logoStyle = 'white', width = '200px' }) => {
    const fillStyle = logoStyle === 'white' ? '#FFFFFF' : '#000000'
    const heightPx = ASPECT_RATIO * Number(width.replace('px', ''))
    const classes = useHeaderLogoStyles()
    return (
      <Box color={fillStyle} width={width} height={heightPx} className={classes.root}>
        <LogoTMSSvg className={classNames(classes.svg, classNameProp)} />
      </Box>
    )
  }
)

export const ReloadTruck = memo<ILogoProps>(({ className = '' }) => {
  return (
    <svg
      className={className}
      width='30'
      height='45'
      viewBox='0 0 30 45'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.4316 15.5169L13.8811 18.2535L19.2868 10.6602'
        stroke='#0072B5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1 14.9251C1.0599 12.1332 1.94324 9.42116 3.53911 7.12953C5.13499 4.8379 7.37228 3.06878 9.97012 2.04427C11.7429 1.31142 13.6534 0.971396 15.5701 1.04759C18.8532 1.14672 22.0009 2.37835 24.4795 4.53362C26.958 6.68888 28.6148 9.6351 29.1689 12.8726C29.5229 15.005 29.2953 17.1935 28.51 19.2074C27.5213 21.7856 26.3206 24.2774 24.9203 26.6572C22.7198 30.4473 20.3118 34.113 17.7071 37.6376C17.479 37.9332 17.2509 38.2288 17.006 38.4822C16.7767 38.7304 16.4984 38.9285 16.1888 39.064C15.8792 39.1995 15.5449 39.2694 15.2069 39.2694C14.8689 39.2694 14.5346 39.1995 14.225 39.064C13.9154 38.9285 13.6372 38.7304 13.4078 38.4822C12.5632 37.3926 11.7185 36.2523 10.8739 35.1036C8.37143 31.5916 6.09475 27.9241 4.05761 24.1233C3.01798 22.1977 2.16929 20.175 1.52368 18.0841C1.19017 17.0637 1.01359 15.9985 1 14.9251V14.9251Z'
        stroke='#394657'
        strokeMiterlimit='10'
      />
      <path
        d='M15.1814 23.8706C20.0375 23.8706 23.9742 19.934 23.9742 15.0779C23.9742 10.2218 20.0375 6.28516 15.1814 6.28516C10.3253 6.28516 6.38867 10.2218 6.38867 15.0779C6.38867 19.934 10.3253 23.8706 15.1814 23.8706Z'
        stroke='#394657'
        strokeMiterlimit='10'
      />
      <path
        d='M23.2143 34.8164C26.9054 35.7117 29.338 37.2405 29.338 38.9721C29.338 41.734 23.1552 43.9639 15.528 43.9639C7.90091 43.9639 1.72656 41.734 1.72656 38.9721C1.72656 37.4264 3.65235 36.0496 6.68462 35.1289'
        stroke='#0072B5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
})
export const RunItAgain = memo<ILogoProps>(({ className = '' }) => {
  return (
    <svg
      className={className}
      width='42'
      height='31'
      viewBox='0 0 42 31'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M26.2285 3.10547V15.4779H33.9841'
        stroke='#0072B5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.7017 12.805C11.5517 13.6637 11.4754 14.5337 11.4736 15.4054C11.4507 19.0043 12.7433 22.4877 15.1083 25.2006C17.4734 27.9134 20.7481 29.6689 24.3165 30.1368C27.885 30.6048 31.5016 29.7531 34.4862 27.7419C37.4708 25.7306 39.6179 22.6983 40.5238 19.2152C41.4297 15.732 41.032 12.0379 39.4054 8.82733C37.7789 5.6168 35.0356 3.11103 31.6912 1.78115C28.3469 0.451267 24.632 0.388875 21.2449 1.60571C17.8578 2.82254 15.0318 5.23478 13.2984 8.38887H3.81836'
        stroke='#394657'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.8311 18.6074H7.12305'
        stroke='#394657'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M13.6917 23.1816H1' stroke='#394657' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  )
})
